module.exports = __webpack_public_path__ + "static/img/Cowboys.106dd86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cowboys.svg
// module id = u+Pv
// module chunks = 0